export default "__VITE_ASSET__DTR2l$gI__"